import { BLANK_TEMPLATE_ID } from '../constants/common';
import isSystemConcept from './is-system-concept';

const isBlankTemplate = (template) =>
  template.templateBuildSlug.endsWith(`-${BLANK_TEMPLATE_ID}`) && isSystemConcept(template.slug);

export default isBlankTemplate;
